import React from "react";
import CashAndCheque from "./index";

const CashBookPage = () => {
  return <CashAndCheque mode="cash" />;
};

export default CashBookPage;


